import {Flag, Variant} from 'rox-ssr';

const FlagsContainer = {
    prescriptionScanerOff: new Flag(false),
    expProgressFunnelM: new Variant('A', ['A', 'B', 'C']),
    myFit: new Flag(false),
    newTryOnPhotos: new Flag(false),
    cartPaypalCredit: new Flag(false),
    checkoutCcHolderName: new Flag(false),
    hideUsaSubscriptionCP: new Flag(false),
    checkoutPhoneFormat: new Flag(false),
    hpRedesignM: new Flag(false),
    expWishlistReminderM: new Flag(false),
    mCheckoutPaymentOsV3: new Flag(false),
    cartPaymentsIcons: new Flag(false),
    cartCouponStaticErrorMessage: new Flag(false),
    stripeCheckoutMobile: new Flag(false),
    expBlackTryOnMPDP: new Flag(false),
    expFooterSubscriptionTextM: new Flag(false),
    expPDPSunglassesButtonsM: new Variant('Control', ['Control', 'Variant 1', 'Variant 2']),
    expPrivacyPolicyM: new Flag(false),
    expLensFunnelLoginMPDP: new Variant('Control', ['Control', 'Variant 1', 'Variant 2']),
    expPDPPriceMatchHouseBrandsM: new Flag(false),
    expPDPSGRecommendationsM: new Flag(false),
    expCategorySortFlag: new Flag(false),
    expTYPCreditCardM: new Flag(false),
    expHPChips: new Variant('Control', ['Control', 'Variation A', 'Variation B']),
    cartUpgradesForItems: new Flag(false),
    isHto: new Flag(false),
    showOrderButtons: new Flag(false),
    cartNewAccessories: new Flag(false),
    expCTPTryOnWidgetMv2: new Flag(false),
    expMenuClearanceVsSaleM: new Flag(false),
    expCTPOpenEyeglassesInNewTab: new Flag(false),
    expCTPOpenSunglassesInNewTab: new Flag(false),
    impactSendConversion: new Flag(true),
    mAppCTPAdjustments3: new Flag(false),
    appHideTryOnPDP: new Flag(false),
    mCartApplePay: new Flag(false),
    mAppLensFunnel: new Flag(false),
    pdpPayinFourFullFunnel: new Flag(false),
    mobilePDPFunnelSunglassesPrices: new Flag(false),
    eyeglassesfunnelPackagesOrder: new Variant('Control', [
        'Control',
        'Variation A',
        'Variation B',
    ]),
    mPDPeyepackageUI: new Flag(false),
    pdpSGpackages: new Flag(false),
    nativeCheckout: new Flag(false),
    quizAiDirectEntry: new Flag(false),
    quizEmailRegistration: new Flag(false),
    wizardSingleTree: new Flag(false),
};

/**
 * HTO flag
 *
 * @returns {boolean} is HTO enabled
 */
export const isHtoEnabled = () => {
    return FlagsContainer.isHto.isEnabled();
};

export default FlagsContainer;
